
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/css/all.min.css" integrity="sha512-Kc323vGBEqzTmouAECnVceyQqyqdsSiqLQISBL29aUW4U/M7pSPA/gEUZQqv1cwx4OnYxTxve5UMg5GT6L4JJg==" crossorigin="anonymous" referrerpolicy="no-referrer" />
<app-landing-page *ngIf="platform=='web'"></app-landing-page>
<section *ngIf="platform=='ios'" class="hero-section bg-white text-white min-vh-100 ptb-120 overflow-hidden position-relative d-flex justify-content-center align-items-center" 
  >
  <div class="container text-center">
      <div class="row justify-content-center">
          <div class="col-lg-12 col-md-12">
              <div class="hero-content-wrap">
                <img src="../../../assets/images/DumyUser/touch.png" alt="" class="img-fluid" style="height: 150px;">
                <div class="typing-container">
                    <h1 class="display-2 fw-bold ail-highlighted-text">
                      {{'DataDriven' | translate}}
                    </h1>
                    <h2 class="display-5 fw-bold ail-highlighted-text">
                     {{'Connectionsatyour' | translate}}  
                    </h2>
                    <h1 class="typing-text  display-6 " style="color: rgb(31, 155, 113);"> 
                      <app-typing-component [textToType]="'fingertips' | translate"></app-typing-component>
                     </h1>
                    <div class="action-btn mt-5">
                        <a routerLink="/ManueDash" class="btn btn-lg btn-primary py-3 shadow px-5" 
                          >
                          {{'openManue' | translate}}
                        </a>
                    </div> 
                </div>
              </div>
          </div>
      </div>
  </div>
</section>



